// @flow

export default function(t: (name: string) => string) {
  return {
    taskKpiExcludeHolidays: {
      "ui:widget": "switch-button",
      "ui:title": t("KPI_EXCLUDE_HOLIDAYS"),
      "ui:options": {
        description: t("KPI_EXCLUDE_HOLIDAYS_DESCRIPTION"),
      },
    },
    taskKpiExcludeWeekends: {
      "ui:widget": "switch-button",
      "ui:title": t("KPI_EXCLUDE_WEEKENDS"),
      "ui:options": {
        description: t("KPI_EXCLUDE_WEEKENDS_DESCRIPTION"),
      },
    },
    "ui:order": ["taskKpiExcludeHolidays", "taskKpiExcludeWeekends", "*"],
  };
}
